import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from '@/model/document2/page/surface/design/design';

// デザインの複製コマンド
export class DuplicateDesignCommand implements ICommandBase
{
    private position! : number;
    private page! : Page;
    private isReverse! : boolean;
    private isHorizontal! : boolean;
    private isVertical! : boolean;
    private doneCallback! : () => void;

    private orgDesignArray : Array<Design | null> = new Array();

    constructor(position : number, page : Page, isReverse : boolean, isHorizontal : boolean, isVertical : boolean, doneCallback : () => void)
    {
        this.position = position;
        this.page = page;
        this.isReverse = isReverse;
        this.isHorizontal = isHorizontal;
        this.isVertical = isVertical;
        this.doneCallback = doneCallback;
        
        // 現在の面にあるすべてのデザインを保持
        for(var i = 0; this.page.designMaxNumber; ++i)
        {
            var design = this.surface.getDesign(i);
            this.orgDesignArray.push(design);
        }
    }

    private get surface() { return this.page.getSurface(this.isReverse); }

    public do() : void
    {
        // デザインの複製
        this.surface.duplicateDesign(this.position, this.isHorizontal, this.isVertical);

        this.doneCallback();
    }

    public undo() : void
    {
        // 保持していたデザインを戻す
        for(var i = 0; i < this.orgDesignArray.length; ++i)
        {
            if(i == this.position) { continue; }
            
            var design = this.orgDesignArray[i];
            if(design != null)
            {
                this.surface.setDesign(i, design);
            }
            else
            {
                this.surface.removeDesign(i);
            }
        }

        this.doneCallback();
    }

    public redo() : void
    {
        // デザインの複製
        this.surface.duplicateDesign(this.position, this.isHorizontal, this.isVertical);

        this.doneCallback();
    }
}